import React, { useState, useEffect } from 'react';
import {
    CarouselContainer,
    Slide,
    SlideImage,
    ArrowButtonLeft,
    ArrowButtonRight,
    DotsWrapper,
    Dot
} from './ScaleComputingCarousel.styles';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';


// Cache-busting helper: append a build version so browsers fetch new images after deploys.
// Set REACT_APP_BUILD_VERSION in your CI/CD (e.g., git commit, timestamp, or release tag).
const BUILD_VERSION =
    process.env.REACT_APP_BUILD_VERSION ||
    process.env.REACT_APP_COMMIT_SHA ||
    'dev';

const withVersion = (path) => `${path}?v=${BUILD_VERSION}`;

// Pure image carousel – no click-through logic
const carouselItems = [
    { imageUrl: withVersion('/Carousel1.png') },
    { imageUrl: withVersion('/Carousel2.png') },
    { imageUrl: withVersion('/Carousel3.png') },
    { imageUrl: withVersion('/Carousel4.png') },
    { imageUrl: withVersion('/Carousel5.png') },

];

const ScaleComputingCarousel = () => {
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prevSlide) => (prevSlide + 1) % carouselItems.length);
        }, 5000);
        return () => clearInterval(interval);
    }, []);

    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
    };

    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + carouselItems.length) % carouselItems.length);
    };

    return (
        <>
            <CarouselContainer>
                <ArrowButtonLeft onClick={prevSlide}>
                    <ArrowBackIosNewIcon style={{ color: '#fff' }} />
                </ArrowButtonLeft>

                {carouselItems.map((item, index) => (
                    <Slide
                        key={index}
                        active={index === currentSlide}
                    >
                        <SlideImage src={item.imageUrl} alt={`Slide ${index + 1}`} />
                    </Slide>
                ))}

                <ArrowButtonRight onClick={nextSlide}>
                    <ArrowForwardIosIcon style={{ color: '#fff' }} />
                </ArrowButtonRight>
            </CarouselContainer>

            <DotsWrapper>
                {carouselItems.map((_, index) => (
                    <Dot
                        key={index}
                        active={currentSlide === index}
                        onClick={() => setCurrentSlide(index)}
                    />
                ))}
            </DotsWrapper>
        </>
    );
};

export default ScaleComputingCarousel;
